module.exports = {"440514001":"峡山街道","440514101":"井都镇","440514103":"成田镇","440514104":"司马浦镇","440514105":"陈店镇","440514106":"两英镇","440514107":"仙城镇","440514108":"胪岗镇","440514109":"红场镇","440514110":"雷岭镇","440514112":"陇田镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440514.json
// module id = 1808
// module chunks = 0